import { IHost } from "@Interfaces";
import { ApiCall, API_ACTIONS, API_ACTION_TYPES } from "@Utils";
import { format, addDays } from "date-fns";

export const validatePincode = (pincode: string) => {
    if (!pincode) return "Required";
    const isValid = /^\d{6}$/.test(pincode);
    return isValid ? "" : "Invalid pincode.";
};

export const getDeliveryEstimate = ({
    listingUuid,
    variationUuid,
    pincode,
    currency,
    isInternationalEnabled,
}: {
    listingUuid: string;
    variationUuid?: string;
    pincode?: string;
    currency?: string;
    isInternationalEnabled: boolean;
}): Promise<IHost.IDeliveryEstimate> =>
    new Promise((resolve, reject) => {
        const apiInfo =
            API_ACTIONS[API_ACTION_TYPES.GET_PINCODE_DELIVERY_ESTIMATE];

        ApiCall({
            url: apiInfo.url({
                listingUuid,
                variationUuid,
                pincode,
                currency,
                isInternationalEnabled,
            }),
            method: apiInfo.method,
        })
            .then((apiResponse: any) => {
                const { status, data, message } = apiResponse?.data || {};
                if (status !== 200) throw new Error(message);
                resolve(data);
            })
            .catch(reject);
    });

export const getDeliveryDate = (days: number) => {
    return format(addDays(new Date(), days), "EEE, MMM dd");
};
